var exports = {
  "_": "xcc377c0b--b5191a--lastUpdated",
  "Q": "xcc377c0b--b5191a--content",
};

module.exports = exports;
